/* eslint-disable jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events */
// @flow
import React from 'react';
import { withRouter } from 'react-router-dom';
import type { RouterHistory } from 'react-router-dom';
// eslint-disable-next-line import/no-unresolved
import core from 'app-client/core.coffee';
import styled from 'styled-components';

const ClientsEventsContainer = styled.span`
  // Override inherited styles from bk-tools-app/backbone/mainapp/app/common/less/common.less
  &#clients-events {
    margin-top: 0;
    top: 16px;
  }
`;

type ClientsEventsCounterProps = {
  localUrlPattern: RegExp,
  history: RouterHistory,
};
/**
 * This component is an awkward React wrapper for the Backbone app's event counter.
 *
 * `core.initClientEvents` will insert the counter along with event handlers to display the
 * event list popup and so forth. Clicks on `<a>` elements within the backbone component will be
 * intercepted so we can transform them to an internal history push call when possible (and save
 * a page refresh).
 */
class ClientsEventsCounter extends React.Component<ClientsEventsCounterProps> {
  componentDidMount() {
    core.initClientsEvents(this.containerElementRef.current);
  }

  containerElementRef = React.createRef();

  handleInternalLinks = ev => {
    if (ev.target && ev.target.tagName === 'A') {
      const href = ev.target.getAttribute('href');
      const { localUrlPattern } = this.props;
      const isInternalLink = href && localUrlPattern.test(href);
      const shouldOpenInNewTab = ev.metaKey;
      if (!isInternalLink) {
        return;
      }
      if (shouldOpenInNewTab) {
        window.open(href, '_blank');
        return;
      }
      ev.preventDefault();
      this.props.history.push(href);
    }
  };

  render() {
    return (
      <ClientsEventsContainer
        ref={this.containerElementRef}
        id="clients-events"
        className="hide"
        onClick={this.handleInternalLinks}
      >
        <span className="total-events" />
      </ClientsEventsContainer>
    );
  }
}

export default withRouter(ClientsEventsCounter);
